import { render } from "./MarketingShell.vue?vue&type=template&id=d7d5dcf0"
import script from "./MarketingShell.vue?vue&type=script&lang=js"
export * from "./MarketingShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__